/* Dozy duvet, pillow and base buy box (a hidden option, e.g. the Platform Base fabric, is filtered out in the Liquid): size + second option (e.g. Warmth), warmth/breathability bars, TOG and fill lines, gallery, open-today, sticky bar, slide-out cart.
   Everything follows the real variants in #dz-pdp-data. */
(function(){
  var root=document.getElementById('dz-pdp'); if(!root) return;
  var data=JSON.parse(document.getElementById('dz-pdp-data').textContent);
  var form=document.getElementById('dz-pdp-form');
  var input=form.querySelector('[data-dz-variant]');
  var sizeBtns=[].slice.call(root.querySelectorAll('.dz-size'));
  var o2Btns=[].slice.call(root.querySelectorAll('[data-o2]'));
  function pressed(list){return list.filter(function(b){return b.getAttribute('aria-pressed')==='true'})[0];}
  var cur={size:(pressed(sizeBtns)||{dataset:{}}).dataset.size,o2:(pressed(o2Btns)||{dataset:{}}).dataset.o2};
  function match(v,size,o2){
    return (!data.sizePos||v.options[data.sizePos-1]===size)&&(!data.o2Pos||v.options[data.o2Pos-1]===o2);
  }
  function find(size,o2){return data.variants.filter(function(v){return match(v,size,o2)})[0];}
  function fmtTog(t){
    if(!t) return '';
    var n=Math.round(t*10)/10, s=String(n).replace(/\.0$/,'');
    var season=t<=5?data.tog.summer:(t<=11?data.tog.all:data.tog.winter);
    return data.tog.prefix+' '+s+(data.tog.season?', '+season:'');
  }
  function drawMeter(m,label,low,high,val){
    if(!m) return;
    m.setAttribute('aria-label',label+': '+val+' out of 10 ('+low+' to '+high+')');
    var top=m.querySelectorAll('.dz-meter__top span'); if(top[1]) top[1].textContent=val+'/10';
    m.querySelectorAll('.dz-meter__bars span').forEach(function(s,i){s.classList.toggle('on',i<val)});
  }
  function setLine(sel,valSel,text){
    var line=root.querySelector(sel); if(!line) return;
    if(line.hasAttribute('data-dz-off')){line.hidden=true;return;}
    var t=root.querySelector(valSel); if(t) t.textContent=text||'';
    line.hidden=!text;
  }
  function setBuyable(ok){
    document.querySelectorAll('[data-dz-atc],[form="dz-pdp-form"][type="submit"]').forEach(function(b){b.disabled=!ok;b.toggleAttribute('aria-disabled',!ok)});
  }
  function update(init){
    // hide option buttons that have no variant for the chosen size
    o2Btns.forEach(function(b){b.hidden=!find(cur.size,b.dataset.o2)});
    var grid=root.querySelector('.dz-feel'); if(grid) grid.style.setProperty('--n',Math.max(o2Btns.filter(function(b){return !b.hidden}).length,1));
    var v=find(cur.size,cur.o2);
    if(!v&&o2Btns.length){
      var fb=o2Btns.filter(function(b){return !b.hidden})[0];
      if(fb){o2Btns.forEach(function(x){x.setAttribute('aria-pressed','false')});fb.setAttribute('aria-pressed','true');cur.o2=fb.dataset.o2;v=find(cur.size,cur.o2);}
    }
    // prices on the buttons follow the other choice
    sizeBtns.forEach(function(b){var x=find(b.dataset.size,cur.o2);var s=b.querySelector('[data-dz-size-price]');if(s) s.textContent=x?x.price:'';});
    o2Btns.forEach(function(b){var x=find(cur.size,b.dataset.o2);var s=b.querySelector('[data-dz-o2-price]');if(s) s.textContent=x?x.price:'';});
    setBuyable(!!(v&&v.available));
    if(!v) return;
    var meters=root.querySelectorAll('[data-dz-meters] .dz-meter');
    drawMeter(meters[0],data.meters.warm,data.meters.warmLow,data.meters.warmHigh,v.warm);
    drawMeter(meters[1],data.meters.breath,data.meters.breathLow,data.meters.breathHigh,v.breath);
    var n=data.notes[cur.o2]||{};
    setLine('[data-dz-tog-line]','[data-dz-tog]',fmtTog(v.tog));
    setLine('[data-dz-weight-line]','[data-dz-weight]',v.weight||n.weight);
    setLine('[data-dz-shell-line]','[data-dz-shell]',v.shell);
    setLine('[data-dz-fill-line]','[data-dz-fill]',v.fill);
    var nt=n.note||v.note||''; var note=root.querySelector('[data-dz-o2-note]'); if(note){note.textContent=nt;note.hidden=!nt;}
    input.value=v.id;
    document.querySelectorAll('[data-dz-price]').forEach(function(e){e.textContent=v.price});
    var sb=pressed(sizeBtns);
    var ob=pressed(o2Btns); var label=(sb?sb.dataset.name:'')+(cur.o2?' · '+((ob&&ob.dataset.label)||cur.o2):'');
    document.querySelectorAll('[data-dz-size-name]').forEach(function(e){e.textContent=label});
    var d=root.querySelector('[data-dz-dims]'); if(d&&sb) d.textContent=sb.dataset.name;
    if(!init) try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString());}catch(e){}
    document.dispatchEvent(new CustomEvent('dz:variant',{detail:{id:v.id,o2:cur.o2,size:cur.size}}));
  }
  sizeBtns.forEach(function(b){b.addEventListener('click',function(){
    sizeBtns.forEach(function(x){x.setAttribute('aria-pressed','false')}); b.setAttribute('aria-pressed','true');
    cur.size=b.dataset.size; update();
  })});
  o2Btns.forEach(function(b){b.addEventListener('click',function(){
    o2Btns.forEach(function(x){x.setAttribute('aria-pressed','false')}); b.setAttribute('aria-pressed','true');
    cur.o2=b.dataset.o2; update();
  })});
  // Other sections (e.g. the warmth cards) can pick an option value: links with data-dz-pick="Summer"
  document.addEventListener('click',function(ev){
    var a=ev.target.closest&&ev.target.closest('[data-dz-pick]'); if(!a) return;
    var b=o2Btns.filter(function(x){return x.dataset.o2===a.getAttribute('data-dz-pick')})[0]; if(!b) return;
    ev.preventDefault(); b.click();
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});
    try{b.focus({preventScroll:true})}catch(e){}
  });
  // add to cart: use the theme's slide-out cart (falls back to the cart page if the drawer is off)
  form.addEventListener('submit',function(ev){
    var drawer=document.querySelector('cart-drawer');
    var t=window.theme||{};
    if(!drawer||(t.settings&&t.settings.cartType==='page')||!window.fetch) return;
    ev.preventDefault();
    var btns=[].slice.call(document.querySelectorAll('[data-dz-atc],[form="dz-pdp-form"][type="submit"]'));
    if(btns.some(function(b){return b.getAttribute('aria-busy')==='true'})) return;
    btns.forEach(function(b){b.setAttribute('aria-busy','true');b.disabled=true});
    var err=root.querySelector('[data-dz-error]');
    if(!err){err=document.createElement('p');err.className='dz-small';err.setAttribute('data-dz-error','');err.setAttribute('role','alert');err.style.color='#A3302A';var bb=form.querySelector('.dz-buy__btns');(bb||form).insertAdjacentElement('afterend',err);}
    err.hidden=true;
    var addUrl=(t.routes&&t.routes.cart_add_url)||'/cart/add';
    var cartUrl=(t.routes&&t.routes.cart_url)||'/cart';
    fetch(addUrl+'.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status){
          var msg=String(res.description||res.message||'');
          if(/variant/i.test(msg)){ err.textContent='These options were just updated. Refreshing the page…'; err.hidden=false; setTimeout(function(){location.reload()},1200); return; }
          err.textContent=msg||'Something went wrong. Please try again.'; err.hidden=false; return;
        }
        return fetch(cartUrl+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
          try{ if(t.pubsub&&t.pubsub.PUB_SUB_EVENTS) t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:input.value,cart:cart}); }catch(e){}
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:res}}));
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:true}}));
        });
      })
      .catch(function(){ form.submit(); })
      .finally(function(){ btns.forEach(function(b){b.removeAttribute('aria-busy')}); var v=find(cur.size,cur.o2); setBuyable(!!(v&&v.available)); });
  });
  // gallery
  var stage=document.getElementById('dz-stage-img');
  // Video thumbnails: the clip only loads when tapped, then plays muted on a loop in place of the main photo. Tap the clip to pause or play.
  var vid=null;
  root.querySelectorAll('.dz-thumb').forEach(function(t){t.addEventListener('click',function(){
    if(!stage) return; root.querySelectorAll('.dz-thumb').forEach(function(x){x.classList.remove('is-on')}); t.classList.add('is-on');
    if(t.dataset.video){
      if(!vid){
        vid=document.createElement('video');
        vid.muted=true; vid.loop=true; vid.autoplay=true; vid.playsInline=true; vid.setAttribute('playsinline',''); vid.setAttribute('preload','auto');
        vid.addEventListener('click',function(){ if(vid.paused) vid.play(); else vid.pause(); });
        stage.parentNode.appendChild(vid);
      }
      if(vid.getAttribute('src')!==t.dataset.video){ vid.poster=t.dataset.poster||''; vid.src=t.dataset.video; }
      vid.setAttribute('aria-label',t.dataset.alt||'');
      vid.style.display=''; stage.style.display='none';
      var pr=vid.play(); if(pr&&pr.catch) pr.catch(function(){});
      return;
    }
    if(vid){ vid.pause(); vid.style.display='none'; }
    stage.style.display='';
    stage.removeAttribute('srcset'); stage.src=t.dataset.src; stage.setAttribute('srcset',t.dataset.srcset); stage.alt=t.dataset.alt;
  })});
  // open today (Toronto time)
  var ot=root.querySelector('[data-dz-open-today]');
  if(ot){try{var d=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',weekday:'short'}).format(new Date());
    var h=d==='Sat'?ot.dataset.sat:(d==='Sun'?'':ot.dataset.week); ot.textContent=h?('Open today '+h+'.'):ot.dataset.closed;}catch(e){}}
  // sticky bar
  var atc=root.querySelector('[data-dz-atc]'), st=document.querySelector('[data-dz-sticky]');
  if(atc&&st&&'IntersectionObserver' in window){new IntersectionObserver(function(e){var show=!e[0].isIntersecting&&e[0].boundingClientRect.top<0;st.classList.toggle('is-on',show);st.setAttribute('aria-hidden',show?'false':'true');}).observe(atc);}
  root.querySelectorAll('.dz-size b').forEach(function(b){ if(b.textContent.indexOf('/')>-1) b.textContent=b.textContent.replace(/\//g,'/​'); });
  update(true);
})();
